import { IAccount } from "interfaces/account.interface";

export enum AddressActionTypes {
  FETCH_ADDRESS_REQUEST = "FETCH_ADDRESS_REQUEST",
  FETCH_ADDRESS_SUCCESS = "FETCH_ADDRESS_SUCCESS",
  FETCH_ADDRESS_FAILURE = "FETCH_ADDRESS_FAILURE",
}

// Action interfaces
export interface FetchAddressRequestAction {
  type: AddressActionTypes.FETCH_ADDRESS_REQUEST;
  payload: {
    address: string;
  };
}

export interface FetchAddressSuccessAction {
  type: AddressActionTypes.FETCH_ADDRESS_SUCCESS;
  payload: IAccount;
}

export interface FetchAddressFailureAction {
  type: AddressActionTypes.FETCH_ADDRESS_FAILURE;
  payload: string;
}

// Action creators
export const fetchAddressRequest = (
  address: string
): FetchAddressRequestAction => ({
  type: AddressActionTypes.FETCH_ADDRESS_REQUEST,
  payload: { address },
});

export const fetchAddressSuccess = (
  data: IAccount
): FetchAddressSuccessAction => ({
  type: AddressActionTypes.FETCH_ADDRESS_SUCCESS,
  payload: data,
});

export const fetchAddressFailure = (
  error: string
): FetchAddressFailureAction => ({
  type: AddressActionTypes.FETCH_ADDRESS_FAILURE,
  payload: error,
});

export type AddressActions =
  | FetchAddressRequestAction
  | FetchAddressSuccessAction
  | FetchAddressFailureAction;
